import template from './add_product_feature_dialog.html';

var AddProductFeaturesDialogViewModel = function(page)
{
	var self = this;
	self.page = page;
	this.product_features = ko.observableArray();
	this.product_version = ko.observable();
	this.file_name = ko.observable();
	this.product_id = ko.observable();
}

var AddProductFeaturesDialogClass = function(bindings)
{
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new AddProductFeaturesDialogViewModel(this);
	this.name = 'Add Feature';

	this.init = function() {
        if (typeof bindings.product_id != "undefined") {
            self.viewModel.product_id(bindings.product_id);
		}
		
		$.postJSON("/grape/list", {schema:'account', tablename: 'product_feature', sortfield: 'name', sortorder: 'desc',filter: [{ value: bindings.product_id, op: '=', field: 'product_id' }] }, function (res) {
			self.viewModel.product_features(res.records);
		});
	};

	this.add_feature = function() {
		$.postJSON('/product_feature/upsert', {
            name:$("#txtFeatureName").val(),
			product_id :self.viewModel.product_id(),
          	}, function(res) {
			self.close(false);
		});
	};

	this.onClose = function() { 
	};

	this.btnclose = function() {
		self.close(false);
	};


}

//Register the dialog
export default {
	name: 'AddProductFeatures',
	dialog_class: AddProductFeaturesDialogClass,
	template: template
};

